module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABHSURBVCiRY2DAAsqCr30uC772GZscCzZBBgYGHhziDEy4JAZOAyPUczjdjAa+kGwDVlAWfO1/WfC1/9jkBmEo4YrpL7g0AACv8w8KgS4nlQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/layout/pages/home/images/add-plus.png
// module id = 2fYZ
// module chunks = 4